import { Routes, Route } from 'react-router-dom';
import { VpcList } from './vpc/VpcList';
import { VpcDetail } from './vpc/VpcDetail';
import { PeeringDetail } from './vpc/PeeringDetail';

/**
 * VPC management: a list home (VPCs / peering groups / peering subnets) plus
 * dedicated detail pages for subnet and peering-member management — mirroring the
 * legacy @console structure (/vpcs, /vpcs/:id, /vpc-peering/:id) rather than dialogs.
 */
export function Vpc() {
  return (
    <Routes>
      <Route index element={<VpcList />} />
      <Route path="peering/:groupId" element={<PeeringDetail />} />
      <Route path=":vpcId" element={<VpcDetail />} />
    </Routes>
  );
}
